/**
 * O período escolhido como instantes de verdade, com fuso: "De" é o
 * começo do dia e "Até" é o fim do dia, os dois na hora LOCAL de quem
 * olha — quem escolhe "até 10/10" espera ver o que mudou às 23h de 10/10.
 *
 * Serve às telas cuja data é carimbo de VERDADE (o instante em que alguém
 * salvou ou editou), como a Auditoria e o Histórico de edições — o oposto
 * da janela de menções, que é hora de parede da clipadora.
 */
export function periodoDaConsulta(de: string, ate: string): {
  changed_from?: string;
  changed_to?: string;
} {
  return {
    ...(de ? { changed_from: new Date(`${de}T00:00:00`).toISOString() } : {}),
    ...(ate ? { changed_to: new Date(`${ate}T23:59:59.999`).toISOString() } : {})
  };
}
